export default __webpack_public_path__ + "static/media/Blank.a2523542.jpg";